import { APEX_API_URL } from '@/constants';
import { IAnnouncementBarItemPopup } from '@/interfaces/homepage';
import { getAxiosInstance } from '@/utils/axios-instance';

interface Params {
  announcementBarId: string;
  itemId: string;
}

export const getAnnouncementBarItemPopup = async ({ announcementBarId, itemId }: Params): Promise<IAnnouncementBarItemPopup> => {
  const { data } = await getAxiosInstance().get(`${APEX_API_URL}/api/campaigns`, {
    params: { announcementBarId, itemId },
  });
  return data;
};
